export default {
    state: {
        searchFilters: {
            priceFilter: {
                min: 0,
                max: 5000
            },
            hotelType: null,
            hotelRating: null,
            // hotelFacilities: null,
            hotelFacilities: [],
        },
        filteredResults: null,
        navigation: false,
        propertyTypes: [
            {
                "id": 16,
                "name": "Guest house",
                "hotelCount": 0
            },
            {
                "id": 9,
                "name": "Apartment",
                "hotelCount": 2
            },
            {
                "id": 0,
                "name": "Hotel",
                "hotelCount": 12
            },
            {
                "id": 2,
                "name": "Inn",
                "hotelCount": 1
            },
            {
                "id": 1,
                "name": "Motel",
                "hotelCount": 19
            },
            {
                "id": 8,
                "name": "Other",
                "hotelCount": 1
            },
            {
                "id": 29,
                "name": "Holiday park/campsite",
                "hotelCount": 1
            },
            {
                "id": 23,
                "name": "Lodge",
                "hotelCount": 1
            }
        ],
        facilities: [
            {
                "id": 2,
                "name": "Room Service",
                "hotelCount": 19
            },
            {
                "id": 3,
                "name": "High-speed Internet",
                "hotelCount": 15
            },
            {
                "id": 6,
                "name": "Parking",
                "hotelCount": 29
            },
            {
                "id": 7,
                "name": "Swimming pool",
                "hotelCount": 25
            },
            {
                "id": 21,
                "name": "Air Conditioned",
                "hotelCount": 32
            },
            {
                "id": 22,
                "name": "Non-Smoking Rooms",
                "hotelCount": 13
            },
            {
                "id": 53,
                "name": "Hair Dryer",
                "hotelCount": 25
            },
            {
                "id": 56,
                "name": "TV",
                "hotelCount": 30
            },
            {
                "id": 57,
                "name": "CD Player",
                "hotelCount": 4
            },
            {
                "id": 58,
                "name": "DVD Player",
                "hotelCount": 10
            },
            {
                "id": 60,
                "name": "Laundry service",
                "hotelCount": 19
            },
            {
                "id": 66,
                "name": "Garden",
                "hotelCount": 12
            },
            {
                "id": 136,
                "name": "Photocopier",
                "hotelCount": 26
            },
            {
                "id": 139,
                "name": "Desk",
                "hotelCount": 4
            },
            {
                "id": 202,
                "name": "WiFi",
                "hotelCount": 24
            },
            {
                "id": 222,
                "name": "Pool Outdoor",
                "hotelCount": 19
            },
            {
                "id": 281,
                "name": "Self Laundry",
                "hotelCount": 26
            },
            {
                "id": 40,
                "name": "Refrigerator",
                "hotelCount": 23
            },
            {
                "id": 47,
                "name": "Wake-up Service",
                "hotelCount": 20
            },
            {
                "id": 51,
                "name": "Coffee / Tea Maker",
                "hotelCount": 25
            },
            {
                "id": 52,
                "name": "Microwave",
                "hotelCount": 17
            },
            {
                "id": 102,
                "name": "Golf (miniature)",
                "hotelCount": 1
            },
            {
                "id": 104,
                "name": "Playground",
                "hotelCount": 7
            },
            {
                "id": 209,
                "name": "Shower",
                "hotelCount": 21
            },
            {
                "id": 210,
                "name": "En suite",
                "hotelCount": 21
            },
            {
                "id": 211,
                "name": "Private Bathroom",
                "hotelCount": 20
            },
            {
                "id": 212,
                "name": "Private Toilet",
                "hotelCount": 20
            },
            {
                "id": 5,
                "name": "Restaurant",
                "hotelCount": 12
            },
            {
                "id": 23,
                "name": "Tennis Courts",
                "hotelCount": 1
            },
            {
                "id": 27,
                "name": "Golf Course",
                "hotelCount": 8
            },
            {
                "id": 30,
                "name": "Conference Room(s)",
                "hotelCount": 4
            },
            {
                "id": 39,
                "name": "Mini Bar",
                "hotelCount": 11
            },
            {
                "id": 41,
                "name": "Cable / Satellite TV",
                "hotelCount": 21
            },
            {
                "id": 49,
                "name": "Meeting Rooms",
                "hotelCount": 5
            },
            {
                "id": 189,
                "name": "Jacuzzi",
                "hotelCount": 1
            },
            {
                "id": 252,
                "name": "Executive Floor",
                "hotelCount": 2
            },
            {
                "id": 258,
                "name": "Ice Machine",
                "hotelCount": 1
            },
            {
                "id": 297,
                "name": "Spa Bath",
                "hotelCount": 3
            },
            {
                "id": 19,
                "name": "Dry Cleaning",
                "hotelCount": 13
            },
            {
                "id": 44,
                "name": "Connecting Rooms",
                "hotelCount": 4
            },
            {
                "id": 243,
                "name": "Packed Lunches",
                "hotelCount": 5
            },
            {
                "id": 298,
                "name": "Kitchenette",
                "hotelCount": 7
            },
            {
                "id": 253,
                "name": "Luggage Storage",
                "hotelCount": 14
            },
            {
                "id": 13,
                "name": "Tour Desk",
                "hotelCount": 5
            },
            {
                "id": 223,
                "name": "Outdoor heated pool",
                "hotelCount": 1
            },
            {
                "id": 229,
                "name": "Games Available",
                "hotelCount": 1
            },
            {
                "id": 4,
                "name": "Fitness Room/Gym",
                "hotelCount": 3
            },
            {
                "id": 10,
                "name": "Disabled Access",
                "hotelCount": 2
            },
            {
                "id": 20,
                "name": "Babysitting / Child Services",
                "hotelCount": 1
            },
            {
                "id": 45,
                "name": "Bath",
                "hotelCount": 2
            },
            {
                "id": 181,
                "name": "Disabled Accessible Rooms",
                "hotelCount": 2
            },
            {
                "id": 221,
                "name": "Pool Indoor",
                "hotelCount": 2
            },
            {
                "id": 11,
                "name": "Concierge",
                "hotelCount": 2
            },
            {
                "id": 17,
                "name": "Elevator / Lift",
                "hotelCount": 2
            },
            {
                "id": 259,
                "name": "Vending Machines",
                "hotelCount": 3
            },
            {
                "id": 299,
                "name": "Free Wi-Fi",
                "hotelCount": 5
            },
            {
                "id": 18,
                "name": "24-Hour Reception",
                "hotelCount": 6
            },
            {
                "id": 242,
                "name": "Picnic Area/Tables",
                "hotelCount": 3
            },
            {
                "id": 15,
                "name": "Bar / Lounge",
                "hotelCount": 3
            },
            {
                "id": 255,
                "name": "Designated Smoking Area",
                "hotelCount": 1
            },
            {
                "id": 292,
                "name": "Free Parking",
                "hotelCount": 2
            },
            {
                "id": 9,
                "name": "Airport shuttle",
                "hotelCount": 1
            },
            {
                "id": 270,
                "name": "Express Check-In/Check-Out",
                "hotelCount": 2
            },
            {
                "id": 35,
                "name": "Sauna",
                "hotelCount": 1
            },
            {
                "id": 1,
                "name": "Business Center",
                "hotelCount": 2
            },
            {
                "id": 193,
                "name": "Spa & Wellness Centre",
                "hotelCount": 1
            },
            {
                "id": 98,
                "name": "Billiards",
                "hotelCount": 1
            }
        ]
    },
    mutations: {
        PRICE_VALUES(state, values) {
            state.searchFilters.priceFilter.min = values.min;
            state.searchFilters.priceFilter.max = values.max
        },
        HOTEL_TYPE(state, value) {
            state.searchFilters.hotelType = value
        },
        HOTEL_RATING(state, value) {
            state.searchFilters.hotelRating = value
        },
        ADVANCE_FILTER_DATA(state, data) {
            state.filteredResults = data.results;
            state.navigation = false
        },
        HOTEL_FACILITIES(state, value) {
            if(value.checked === false) {
                const x = state.searchFilters.hotelFacilities.filter(i => i !== value.id)
                state.searchFilters.hotelFacilities = x
            }else {
                let array = state.searchFilters.hotelFacilities;
                array.push(value.id)
                state.searchFilters.hotelFacilities = array
            }
        },
        SEARCH_NAVIGATION(state, value) {
            state.navigation = value
        },
        NULLIFY_FILTERED_RESULTS_MUT(state) {
            state.filteredResults = null;
        }
    },
    actions: {
        NULLIFY_FILTERED_RESULTS(ctx) {
            ctx.commit('NULLIFY_FILTERED_RESULTS_MUT')
        },
        PRICE_FILTER_VALUES(ctx, values) {
            ctx.commit('PRICE_VALUES', values)
        },
        HOTEL_TYPE_FILTER_VALUE(ctx, value) {
            ctx.commit('HOTEL_TYPE', value)
        },
        HOTEL_FILTER_RATING(ctx, value) {
            ctx.commit('HOTEL_RATING', value)
        },
        HOTEL_FILTER_FACILITIES(ctx, value) {
            ctx.commit('HOTEL_FACILITIES', value)
        },
        ADVANCE_FILTER(ctx, data) {
            ctx.commit('ADVANCE_FILTER_DATA', data)
        },
        ADVANCED_SEARCH_NAVIGATION(ctx, value) {
            ctx.commit('SEARCH_NAVIGATION', value)
        }
    },
    getters: {}
}